import {useIntl} from 'react-intl';
import {matrixService} from '../../../services/matrixService';
import {callPeople} from '../../groupCalls/services/callPeople';
import {groupCallService} from '../../groupCalls/services/groupCallService';
import {summarizePeople} from '../model/callNames';
import {callsMessages as m} from './callsMessages';

const memberName = (roomId: string, userId: string): string =>
    matrixService.getRoom(roomId)?.getMember(userId)?.name || userId;

export const useCallPeopleText = (roomId: string, userIds: readonly string[], max: number): string | undefined => {
    const intl = useIntl();
    const me = groupCallService.localUserId;
    const names = callPeople(userIds).filter(userId => userId !== me).map(userId => memberName(roomId, userId));
    const everyone = matrixService.getRoom(roomId)?.getJoinedMembers().map(member => member.name || member.userId) ?? names;
    const summary = summarizePeople(names, max, everyone);
    if (summary.kind === 'none') {
        return undefined;
    }
    if (summary.kind === 'list') {
        return intl.formatList(summary.names, {type: 'conjunction'});
    }
    return intl.formatMessage(m.peopleMore, {names: summary.names.join(', '), more: summary.more});
};
